const PERMISSION_ALLOWED = true;
const PERMISSION_DENIED = false;

const basicScopes = ['Basic User', 'Call Center Agent'];

// eslint-disable-next-line
export default (user, actionId) => {
  switch (actionId) {
    case 'CREATE_BOARDS':
    case 'EDIT_BOARDS':
      if (!user) { // if there is no user
        return PERMISSION_DENIED;
      }

      if (basicScopes.includes(user.scope)) { // if user scope is basic
        return PERMISSION_DENIED;
      }
      return PERMISSION_ALLOWED; // if passed all other conditions
    default:
  }
};
